import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { SharedModule } from '../shared/shared.module';
import { ViewStudentOnboardingComponent } from './view-student-onboarding/view-student-onboarding.component';
import {MatIconModule} from '@angular/material/icon';

@NgModule({
  declarations: [
    ViewStudentOnboardingComponent // Declare the component
  ],
  imports: [
    CommonModule,
    MatDividerModule,
    SharedModule,
    MatIconModule 
  ],
  exports: [
    ViewStudentOnboardingComponent, // Export the component for use in other modules
  ],
})
export class OnboardingModule {}